module.exports = __webpack_public_path__ + "static/media/top-view-transparent.3b93c777.png";